// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DropDownMenu-menuBg-DXdJB {
    width: 78px;
    height: 44px;
    background: #E9E9E957;
    border-radius: 12px;
    display: grid;
    grid-template-columns: 50% 50%;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    padding: 0 10px 0 12px;
    position: relative;
    border: 1px solid var(--primary-border)
}

.DropDownMenu-icon-VZZhF {
    height: 50px
}

.DropDownMenu-userAvatar-hYb8g {
    border-radius: 50%;
}

.DropDownMenu-userAvatarNotifyIcon-LuwFP {
    background-color: var(--alert-color);
    height: 10px;
    width: 10px;
    position: absolute;
    border-radius: 50%;
    display: inline-block;
    top: 0;
    right: 0;
    -webkit-transform: translateY(-40%);
        -ms-transform: translateY(-40%);
            transform: translateY(-40%);
}

.DropDownMenu-moveTop-LlKyT {
    position: relative;
    top: -2px
}`, "",{"version":3,"sources":["webpack://./src/components/DropDownMenu/DropDownMenu.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,MAAM;IACN,QAAQ;IACR,mCAA2B;QAA3B,+BAA2B;YAA3B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB;AACJ","sourcesContent":[".menuBg {\n    width: 78px;\n    height: 44px;\n    background: #E9E9E957;\n    border-radius: 12px;\n    display: grid;\n    grid-template-columns: 50% 50%;\n    align-items: center;\n    justify-content: center;\n    padding: 0 10px 0 12px;\n    position: relative;\n    border: 1px solid var(--primary-border)\n}\n\n.icon {\n    height: 50px\n}\n\n.userAvatar {\n    border-radius: 50%;\n}\n\n.userAvatarNotifyIcon {\n    background-color: var(--alert-color);\n    height: 10px;\n    width: 10px;\n    position: absolute;\n    border-radius: 50%;\n    display: inline-block;\n    top: 0;\n    right: 0;\n    transform: translateY(-40%);\n}\n\n.moveTop {\n    position: relative;\n    top: -2px\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuBg": `DropDownMenu-menuBg-DXdJB`,
	"icon": `DropDownMenu-icon-VZZhF`,
	"userAvatar": `DropDownMenu-userAvatar-hYb8g`,
	"userAvatarNotifyIcon": `DropDownMenu-userAvatarNotifyIcon-LuwFP`,
	"moveTop": `DropDownMenu-moveTop-LlKyT`
};
module.exports = ___CSS_LOADER_EXPORT___;
